<template>
  <div class="register">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>

    <v-registerTop :navTitle="navTitle" :webConfigInfo='webConfigInfo'></v-registerTop>
    <!--<div class="setNavBg">-->
    <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' ></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>{{titleName}}</h3></div>
    <div class="registerStepCon">
      <div class="stepsBox">
        <el-steps :active="2" align-center id="steps">
          <el-step title="1 填写企业信息"></el-step>
          <el-step title="2 完善个人信息"></el-step>
          <el-step title="3 提交审核"></el-step>
          <el-step title="4 完成注册"></el-step>
        </el-steps>
      </div>
      <div class="examineCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerFailed.png" alt="">
        <h5>您的注册申请已经被驳回，请按驳回原因修改后重新提交审核</h5>
        <h5>原因：{{exmaineMessage}}</h5>
      </div>
      <el-button @click="goToHref()">重新编辑</el-button>
    </div>
    
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        webConfigInfo: {},
        checkList:[],
        navTitle:'注册',
        abroadShow:false,
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        email:'',
        companyId:'',
        companyName:'',
        orgIdentity:'',
        regAddrType:'',
        userId:'',
        regeisterType:'',
        exmaineMessage:'',
        createUserId:'',
        titleName:''
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      let query = this.$route.query;
      this.email  = query.email;
      this.companyId = query.companyId;
      this.companyName = query.companyName;
      this.orgIdentity = query.orgIdentity;
      this.regAddrType = query.regAddrType;
      this.userId = query.userId;
      this.regeisterType = query.regeisterType;
      this.exmaineMessage = query.exmaineMessage;
      this.createUserId = query.createUserId;
      if(this.orgIdentity == '20'){
        this.titleName = '采购商注册';
      }
      if(this.orgIdentity == '10'){
        this.titleName = '供应商注册';
      }
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      
    }).catch((err) => {
        console.log(err)
    })
    },
    mounted () {
      this.ulWidth();
    },
    methods: {
      ulWidth () {
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
//        if($('.tabTitle').width() < 750){
          // 动态计算ul的宽度
          let scrollwrap = $('.el-steps').eq(0)
          let lis = $('.el-step', scrollwrap)
          let sum = 0
          // 遍历每一个li元素
          lis.each(function (index, el) {
            let _el = $(el)
            // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
            // outerWidth 代表的是border+padding+width
            sum += _el.width()
          })
          // 将累加的值直接复制给ul元素
          scrollwrap.width(1200)
//          this.positionSteps();
//        }
        }
    
      },
      positionSteps(){
        $("#steps").animate({scrollLeft: 500}, 200)
//        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
////          $("#steps").scrollLeft(100)
//          $("#steps").animate({scrollLeft: 500}, 200)
//        }
      },
      goToHref(){
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.$alert('<p>请到PC端重新编辑注册信息</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
          return;
        } else {
          if(this.createUserId == this.userId){
            this.$router.push({path: '/registerBusinessInfo',query:{userId:this.userId,email:this.email,companyId:this.companyId,companyName:this.companyName,orgIdentity:this.orgIdentity,regAddrType:this.regAddrType,regeisterType:this.regeisterType}})
          }else {
            this.$router.push({path: '/registerExistBusinessInfo',query:{userId:this.userId,email:this.email,companyId:this.companyId,companyName:this.companyName,orgIdentity:this.orgIdentity,regAddrType:this.regAddrType,regeisterType:this.regeisterType}})
          }
          return;
        }
        
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registerFailed/index.vue